import { useSelector } from "react-redux";
import { Typography, makeStyles, Grid } from "@material-ui/core";

import { currencyFormatter } from "../../../../services/utils";
import { IconLabelButton } from "./IconLabelButton";

const useStyles = makeStyles(() => ({
  container: {
    paddingLeft: "24px !important",
  },
  body1: {
    lineHeight: "18px",
    letterSpacing: "0.2px",
  },
}));

export const IncreasePowerRevenuesRecommendation = ({
  iconSrc,
  label,
  numberOfRecommendations,
  potentialRevenues,
}) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <IconLabelButton iconSrc={iconSrc} width={400} height={100} padding="16px 0px 14px 28px">
          {label}
        </IconLabelButton>
      </Grid>
      <Grid container item direction="column" className={classes.container}>
        <Grid item>
          <Typography variant="body1" className={classes.body1}>
            {numberOfRecommendations} recommendations
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" className={classes.body1}>
            Est. revenues potential: {currencyFormatter(potentialRevenues, currencySymbol)}/Year
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
